// Central site content & config — edit here to update the website.

const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const CLINIC = {
  name: "FizioFit Center",
  tagline: "Klinikë Fizioterapie në Lushnjë",
  logo: `${PUBLIC_URL}/logo.webp`,
  phone: "+355 68 829 5331",
  phoneRaw: "+355688295331",
  whatsapp: "355688295331",
  address: "Rruga Faik Dervishi, Lushnjë, Albania",
  addressShort: "Lushnjë, Albania",
  hours: "08:00 – 21:00",
  rating: "5.0",
  reviews: "21+",
  mapsUrl: "https://maps.app.goo.gl/rmjJTLLE73yuf5TV9",
  mapsEmbed:
    "https://maps.google.com/maps?q=40.9353375,19.7109138&z=16&output=embed",
  facebook: "https://www.facebook.com/fiziofitcenter/",
  instagram: "https://www.instagram.com/fiziofit_center/",
};

// Vendosni linkun tuaj te Google Apps Script ketu nese deshironi:
export const GOOGLE_SHEET_URL = "";

export async function submitBookingForm(formData) {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
  const bookingEndpoint = `${BACKEND_URL}/api/bookings.php`;

  try {
    const res = await fetch(bookingEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (res.ok) {
      const data = await res.json();
      if (data.success === true) {
        return { success: true, data };
      }
    } else {
      // Try to parse JSON error response, fallback to status text if HTML
      let errorMsg = `HTTP ${res.status}`;
      try {
        const error = await res.json();
        errorMsg = error.error || error.detail || errorMsg;
      } catch {
        // Response is not JSON (likely HTML error page)
        errorMsg = `API Error ${res.status}: ${res.statusText}. Kontrolloni nëse API është në dispozicion.`;
      }
      throw new Error(errorMsg);
    }
  } catch (e) {
    console.error("Booking form error:", e);
    throw new Error(e.message || "Ndodhi një gabim. Provoni përsëri.");
  }
}

export const whatsappLink = (msg) =>
  `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(
    msg || "Përshëndetje, dëshiroj informacion rreth FizioFit Center."
  )}`;

export const telLink = `tel:${CLINIC.phoneRaw}`;

export const NAV_LINKS = [
  { label: "Kryefaqja", href: "#hero" },
  { label: "Rreth Nesh", href: "#about" },
  { label: "Shërbimet", href: "#services" },
  { label: "Trajtimet", href: "#conditions" },
  { label: "Galeria", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#contact" },
];

export const IMAGES = {
  logo: `${PUBLIC_URL}/logo.webp`,
  drErlind: `${PUBLIC_URL}/images/dr-erlind-logo.png`,
  hero: `${PUBLIC_URL}/images/bg.png`,
  about: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.10.jpeg`,
  gallery: [
    {
      src: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.04.jpeg`,
      alt: "Pamja e jashtme e klinikës FizioFit Center",
      span: "col-span-2 lg:col-span-2 row-span-2 min-h-[300px]",
    },
    {
      src: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.10.jpeg`,
      alt: "Ambienti modern dhe aparaturat e avancuara",
      span: "col-span-2 lg:col-span-2 row-span-2 min-h-[300px]",
    },
    {
      src: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.18.jpeg`,
      alt: "Krevati profesional i terapisë manuale",
      span: "col-span-1 lg:col-span-1 min-h-[220px]",
    },
    {
      src: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.07.jpeg`,
      alt: "Hyrja e FizioFit Center Dr. Erlind Mara",
      span: "col-span-1 lg:col-span-1 min-h-[220px]",
    },
    {
      src: `${PUBLIC_URL}/images/WhatsApp Image 2026-08-27 at 19.21.26.jpeg`,
      alt: "Pajisjet e ushtrimeve terapeutike dhe rehabilitimit",
      span: "col-span-2 lg:col-span-2 min-h-[220px]",
    },
  ],
};

export const DOCTOR = {
  name: "Dr. Erlind Mara",
  role: "Fizioterapist Klinik & Drejtues i FizioFit Center",
  photo: `${PUBLIC_URL}/images/dr-erlind-logo.png`,
  university: "Universiteti Katolik 'Zoja e Këshillit të Mirë'",
  universityNote: "Shkolla dhe universiteti më elitar dhe prestigjioz i fizioterapisë në Shqipëri",
  specializations: [
    "Kurs i Avancuar i Certifikuar në Metodën Mézières (Riedukim Postural Global)",
    "Kurs i Avancuar i Certifikuar në Maitland Concept (Terapia Manuale Ortopedike)",
    "Standardet Ndërkombëtare IFOMPT për Trajtimin Neuromuskuloskeletik",
    "Specializim në Rehabilitimin Pas Ndërhyrjeve Kirurgjikale & Dëmtimeve Sportive",
  ],
};

export const SERVICES = [
  {
    icon: "Activity",
    title: "Fizioterapi",
    desc: "Vlerësim dhe trajtim i çrregullimeve të lëvizjes, për të reduktuar dhimbjen dhe përmirësuar funksionin.",
  },
  {
    icon: "HeartPulse",
    title: "Rehabilitim",
    desc: "Programe të strukturuara rikuperimi për të rikthyer forcën, ekuilibrin dhe lëvizshmërinë.",
  },
  {
    icon: "Hand",
    title: "Terapia Manuale",
    desc: "Teknika me duar për nyjet dhe indet e buta, që lehtësojnë dhimbjen dhe tensionin.",
  },
  {
    icon: "Stethoscope",
    title: "Rehabilitim pas operacioneve",
    desc: "Ndjekje e kujdesshme e rikuperimit pas ndërhyrjeve, hap pas hapi.",
  },
  {
    icon: "Dumbbell",
    title: "Rehabilitim pas dëmtimeve sportive",
    desc: "Rikthim i sigurt në aktivitet për sportistët amatorë dhe profesionistë.",
  },
  {
    icon: "Bone",
    title: "Dhimbje muskulore & artikulare",
    desc: "Trajtim i dhimbjeve të muskujve dhe nyjeve me qasje të personalizuar.",
  },
  {
    icon: "Brain",
    title: "Rehabilitim neurologjik",
    desc: "Mbështetje për rikuperimin e lëvizjes dhe koordinimit pas gjendjeve neurologjike.",
  },
  {
    icon: "StretchHorizontal",
    title: "Ushtrime terapeutike",
    desc: "Programe individuale ushtrimesh për të forcuar dhe stabilizuar trupin.",
  },
  {
    icon: "Waves",
    title: "Trajtime me aparatura",
    desc: "Përdorim i aparaturave moderne të fizioterapisë sipas nevojës së trajtimit.",
  },
];

export const CONDITIONS = [
  "Dhimbje shpine & hernie diskale",
  "Dhimbje qafe & shpatullash",
  "Dhimbje gjuri & ligamente",
  "Probleme muskulore & kontraktura",
  "Probleme artikulare & artrit",
  "Dëmtime sportive & ndrydhje",
  "Rehabilitim pas operacionit",
  "Kufizim të lëvizshmërisë",
  "Rehabilitim pas frakturave",
  "Skoliozë & korrigjim qëndrimi",
];

export const WHY = [
  {
    icon: "UserCheck",
    title: "Trajtim i personalizuar",
    desc: "Çdo pacient ka nevoja të ndryshme — programi ndërtohet posaçërisht për ju.",
  },
  {
    icon: "ShieldCheck",
    title: "Kujdes profesional",
    desc: "Fokus i plotë te pacienti dhe te procesi i sigurt i rikuperimit.",
  },
  {
    icon: "Cpu",
    title: "Pajisje moderne",
    desc: "Aparatura të avancuara të përshtatshme për fizioterapi dhe rikuperim.",
  },
  {
    icon: "Building2",
    title: "Ambient mikpritës",
    desc: "Një hapësirë e pastër, komode dhe e dedikuar për shëndetin tuaj.",
  },
  {
    icon: "Target",
    title: "Fokus te rezultatet",
    desc: "Programe të matshme që përshtaten hap pas hapi sipas ecurisë suaj.",
  },
  {
    icon: "Clock",
    title: "Hapur çdo ditë",
    desc: "Orar fleksibël nga 08:00 deri në 21:00, shtatë ditë të javës.",
  },
];

export const PROCESS = [
  { n: "01", title: "Konsultimi", desc: "Vlerësimi fillestar dhe kuptimi i thellë i problemit tuaj." },
  { n: "02", title: "Plani i Trajtimit", desc: "Identifikimi i metodave më efektive dhe përcaktimi i objektivave." },
  { n: "03", title: "Trajtimi & Terapia", desc: "Kombinim i terapisë manuale, aparaturave dhe ushtrimeve aktive." },
  { n: "04", title: "Rikuperimi i Plotë", desc: "Monitorim i vazhdueshëm i progresit dhe udhëzime parandaluese." },
];

export const TESTIMONIALS = [
  {
    name: "Arben K.",
    text: "Pasi vuaja për muaj me radhë nga dhimbja e mesit, me trajtimet në FizioFit Center munda të kthehem në aktivitet normal brenda pak javësh. Përkushtim dhe profesionalizëm maksimal!",
    role: "Google Review · Pacient",
  },
  {
    name: "Elena M.",
    text: "Rehabilitimi pas operacionit të ligamentit të gjurit shkoi shkëlqyeshëm falë kujdesit të stafit. Ambienti është shumë i pastër dhe aparaturat moderne bëjnë diferencën.",
    role: "Google Review · Paciente",
  },
  {
    name: "Genti D.",
    text: "Shërbim i shkëlqyer dhe staf shumë i sjellshëm. Më ndihmuan jashtëzakonisht me dëmtimin tim sportiv në shpatull. I rekomandoj me bindje të plotë për këdo në Lushnjë!",
    role: "Google Review · Pacient",
  },
];

export const FAQ = [
  {
    q: "Çfarë është fizioterapia dhe si më ndihmon?",
    a: "Fizioterapia është disiplinë mjekësore që ndihmon në rikthimin e lëvizshmërisë dhe funksionit optimal të trupit, duke eliminuar dhimbjet përmes terapisë manuale, ushtrimeve terapeutike dhe aparaturave bashkëkohore.",
  },
  {
    q: "Sa zgjat një seancë trajtimi?",
    a: "Kohëzgjatja varet nga lloji i trajtimit dhe nevojat specifike të pacientit. Zakonisht një seancë zgjat midis 40 deri në 60 minuta. Plani i detajuar përcaktohet pas konsultës fillestare.",
  },
  {
    q: "A duhet të rezervoj takim paraprakisht?",
    a: "Po, rekomandohet gjithmonë të rezervoni paraprakisht në mënyrë që të mund t'ju dedikojmë kohën dhe vëmendjen maksimale. Mund të rezervoni direkt online në faqe, me telefon ose në WhatsApp.",
  },
  {
    q: "A trajtoni dëmtime sportive dhe kontraktura?",
    a: "Po! Ofrojmë programe të specializuara të rehabilitimit sportiv për rikthim të sigurt dhe të shpejtë në stërvitje, si për atletët profesionistë ashtu edhe për dashamirësit e sportit.",
  },
  {
    q: "A ofroni rehabilitim pas ndërhyrjeve kirurgjikale?",
    a: "Po, ndjekim protokolle të certifikuara të rikuperimit pas operacioneve ortopedike (gju, shpatull, shtyllë kurrizore, fraktura) për rikthimin gradual dhe të plotë të funksionit motorik.",
  },
  {
    q: "Ku ndodhet FizioFit Center dhe cili është orari?",
    a: "Klinika ndodhet në Rrugën Faik Dervishi në Lushnjë. Jemi hapur çdo ditë nga e Hëna në të Diel, ora 08:00 deri në 21:00.",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
